import request from './request';

// 获取所有调用步骤（树形结构）
export function getCallSteps() {
  return request({
    url: '/call-steps',
    method: 'get'
  });
}

// 获取所有调用步骤（平铺列表）
export function getCallStepsFlat() {
  return request({
    url: '/call-steps/flat',
    method: 'get'
  });
}

// 获取调用步骤详情
export function getCallStepById(id) {
  return request({
    url: `/call-steps/${id}`,
    method: 'get'
  });
}

// 创建调用步骤
export function createCallStep(data) {
  return request({
    url: '/call-steps',
    method: 'post',
    data
  });
}

// 更新调用步骤
export function updateCallStep(id, data) {
  return request({
    url: `/call-steps/${id}`,
    method: 'put',
    data
  });
}

// 删除调用步骤
export function deleteCallStep(id) {
  return request({
    url: `/call-steps/${id}`,
    method: 'delete'
  });
}

